module.exports = __webpack_public_path__ + "img/graphique-page-vente.05e65d22.jpg";